import { useEffect } from "react";

export default function CurrentEnvironment() {
  const currentHost = new URL(window.location.href);
  const availableEnvironments = [
    { key: "local", label: "localhost", url: "http://localhost:3000" },
    { key: "dev", label: "Dev", url: "https://dev.app.storyboardtesting.com" },
    { key: "staging", label: "Staging", url: "https://staging.app.storyboardtesting.com" },
    { key: "prod", label: "Production", url: "https://app.storyboard.com" },
  ].filter((option) => currentHost?.host?.includes(new URL(option.url)?.host));

  const activeEnv = availableEnvironments?.length === 1 ? availableEnvironments[0] : null;

  /**
   * If the active environment is production, we do not need to display the environment label.
   */
  if (activeEnv?.key === "prod") {
    return <></>;
  }

  /**
   * Manually update the document title to include the environment label.
   */
  useEffect(() => {
    if (document?.title?.includes("[")) {
      return;
    }
    document.title = `${document?.title} [${activeEnv?.label || "Unknown Environment"}]`;
  }, [activeEnv]);
  return <></>;
}
